import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import optimist from 'redux-optimist'
import { enableBatching } from 'redux-batched-actions'
import kanboReducer from './redux'
import viewHomeReducer from 'routes/Home/redux'
import viewUserGroupsReducer from 'routes/UserGroups/redux'
import viewBoardReducer from 'routes/Board/redux'
import viewMyBoardReducer from 'routes/MyBoard/redux'
import viewCardReducer from 'routes/Card/redux'

export default () =>
  optimist(enableBatching(combineReducers({
    kanbo: kanboReducer,
    form: formReducer,
    'view-home': viewHomeReducer,
    'view-userGroups': viewUserGroupsReducer,
    'view-board': viewBoardReducer,
    'view-myboard': viewMyBoardReducer,
    'view-card': viewCardReducer
  })))
